import {Configuration, RegisterUPS, RegistrationApi, UPSAccount} from '@shipwell/backend-core-sdk';
import {RegistrationApiRegistrationUPSGetRequest} from '@shipwell/backend-core-singlerequestparam-sdk';
import {AxiosResponse} from 'axios';
import {basePath} from 'App/api/config';
import {getAccessToken} from 'App/api/utils';

function createRegistrationApi() {
  return new RegistrationApi(
    new Configuration({
      basePath,
      apiKey: getAccessToken
    })
  );
}

export type RegistrationApiRegistrationUPSGetResponse = {
  results: Array<UPSAccount>;
  page_size: number;
  total_count: number;
  total_pages: number;
};

export const getUPSRegistrationAccounts = async ({accountNumber}: RegistrationApiRegistrationUPSGetRequest) =>
  (await createRegistrationApi().registrationUPSGet(
    accountNumber
  )) as AxiosResponse<RegistrationApiRegistrationUPSGetResponse>;

export const registrationUPSUpsAccountIdDelete = async (upsAccountId: string) =>
  await createRegistrationApi().registrationUPSUpsAccountIdDelete(upsAccountId);

export const registrationUPSPost = async (upsAccount: RegisterUPS) =>
  await createRegistrationApi().registrationUPSPost(upsAccount);
